import React, { useEffect } from 'react'
import Modal from 'src/components/Modal'
import * as S from './style'
import { useForm } from 'react-hook-form'
import { Typography } from '@mui/material'
import { recountValidateUser } from 'src/services/receivement/divergenceService'
import { actions as appActions } from 'src/features/state'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'

const ModalNewBadgeForRecount = ({
  batchId,
  batchCreatedBy,
  onSuccess,
  onClose,
}) => {
  const {
    register,
    reset,
    formState: { errors, isSubmitting },
    handleSubmit,
  } = useForm()

  useEffect(() => {
    reset()
  }, [batchId])

  const dispatch = useDispatch()

  const onSubmit = async ({ newBadge }) => {
    if (isSubmitting) {
      return
    }

    try {
      dispatch(appActions.isLoading(true))

      const result = await recountValidateUser(batchId, newBadge)
  
      if (result.isOk) {
        onSuccess(newBadge)
      } else {
        toast.error(result?.data?.message || 'Falha ao validar se usuário tem permissão para recontar o lote!')
      }
    } catch (error) {
      toast.error('Falha ao validar usuário!')
    } finally {
      dispatch(appActions.isLoading(false))
    }
  }

  return (
    <Modal
      show={batchId !== undefined}
      testId='modal-new-badge-for-recount-test-id'
      centered
      title={`Recontagem do lote ${batchId || ''}`}
      closeButtonAction={onClose}
      closeButtonDisabled={isSubmitting}
      body={(
        <S.Container>
          <S.ContainerInfo>
            <Typography variant='body1'>
              O usuário que realizou a contagem deste lote não pode ser o mesmo que irá recontá-lo.
            </Typography>
            {batchCreatedBy && (
              <Typography variant='body1'>
                Este lote foi contado por {batchCreatedBy}
              </Typography>
            )}
            <Typography variant='body1'>
              Chame um outro fiscal/supervisor!
            </Typography>
          </S.ContainerInfo>
          <S.CustomTextField
            id='newBadge'
            name='newBadge'
            label='Crachá'
            type='password'
            autoComplete='off'
            autoFocus
            inputProps={{
              ...register('newBadge', {
                required: 'Campo obrigatório!',
              }),
              'data-testid': 'new-badge-input-test-id',
            }}
            error={!!errors.newBadge}
            helperText={errors.newBadge?.message}
            size='medium'
            fullWidth
            sx={{
              '& .MuiInputLabel-outlined': {
                transform: 'translate(14px, 13px) scale(1) !important',
              },
              '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
                transform: 'translate(14px, -9px) scale(0.75) !important',
              }
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault()
                handleSubmit(onSubmit)()
              }
            }}
          />
        </S.Container>
      )}
    />
  )
}

export { ModalNewBadgeForRecount }
